import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import { addPayment, getAccList } from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const AddPayment = () => {
  const navigate = useNavigate();
  const { storeG } = useStateContext();
  const [accountFrom, setAccountFrom] = useState([]);
  const [accountTo, setAccountTo] = useState([]);
  const [formData, setFormData] = useState({
    account_from: "select",
    account_to: "select",
    amount: "0.0",
    notes: "",
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const formatCurrency = (number) => {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Payment");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    if (
      !newErrors["account_from"] &&
      formData.account_from.value === formData.account_to.value
    )
      newErrors["account_from"] = "Choose a different Account!";
    if (
      !newErrors["amount"] &&
      !newErrors["account_from"] &&
      parseFloat(formData.amount) > parseFloat(formData.account_from.balance)
    )
      newErrors["amount"] = "Amount should be less than Account balance!";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    try {
      const response = await addPayment(
        formData.account_from.value,
        formData.account_to.value,
        10,
        formData.amount,
        null,
        formData.notes,
      );
      if (response.success) {
        showSuccessToast("Success!", "Payment added successfully.");
        navigate("/Payment");
      } else
        showErrorToast(
          "Error!",
          "Payment failed to add!\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "Payment failed to add!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        TimeoutUtility.resetTimeout();
        await getAccList(storeG.store_id)
          .then((resp) => {
            const accOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.account_id,
              balance: item.balance,
              open_datetime: item.open_datetime,
            }));
            setAccountFrom(accOptions || []);
            setAccountTo(accOptions || []);
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="ADD PAYMENT" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} sm={8} className="container-col">
              <div className="col-lg-12">
                <SelectField
                  label="Paid To:"
                  name="account_to"
                  value={formData.account_to}
                  options={accountTo}
                  onChange={handleSelectChange}
                  placeholder="Paid To Account"
                  compulsory={true}
                  error={errors.account_to}
                />
                <SelectField
                  label="Paid From:"
                  name="account_from"
                  value={formData.account_from}
                  options={accountFrom}
                  onChange={handleSelectChange}
                  placeholder="Paid From Account"
                  compulsory={true}
                  error={errors.account_from}
                />
                <DoubleField
                  label="Amount Paid:"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  placeholder="Amount Paid"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.amount}
                />
                <TextAreaField
                  label="Notes:"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Notes"
                  error={errors.notes}
                />
              </div>
            </Col>
            <Col md={2} sm={2} className="container-col">
              <div className="col-lg-12">
                <div className="form-group mt-12">
                  <label className="label">
                    Bal: {formatCurrency(formData.account_to?.balance ?? 0)}
                  </label>
                </div>
                <div className="form-group mt-14">
                  <label className="label">
                    Bal: {formatCurrency(formData.account_from?.balance ?? 0)}
                  </label>
                </div>
              </div>
              <br />
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Add"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddPayment;
